function runAt(selector, callback) {
  function check() {
    if (document.querySelector(selector)) {
      callback();
    } else {
      requestAnimationFrame(check);
    }
  }
  requestAnimationFrame(check);
}

function getSelectors() {
  const quizMain = document.querySelector(".hn_quiz--section");
  const questionScript = quizMain.querySelector("#hn_quiz--scripts");
  const parsedData = JSON.parse(questionScript.textContent);
  const quizData = parsedData.quiz_container;
  const resultData = parsedData.result_container;
  return {
    quizMain,
    quizData,
    resultData,
    headerContainer: quizMain.querySelector(".hn_quiz--header"),
    questionContainer: quizMain.querySelector(".hn_question--container"),
    resultContainer: quizMain.querySelector(".hn_result--container"),
    stepTracker: quizMain.querySelector(".hn_step-tracker"),
    resultOverlay: quizMain.querySelector(".hn--overlay"),
    questionOverlay: quizMain.querySelector(".hn--overlay_2"),
  };
}

let selectors = getSelectors();
let selectedAnswers = selectors.quizData.map((q) =>
  q.type === "multiple answer" ? [] : null
); // Initialize based on type
let currentQuestionIndex = 0;

function globalFunction() {
  renderQuestion(selectors);
  renderPrevButton(selectors);
}

function renderStepPagination(selectors, currentStep, totalSteps) {
  const tracker = selectors.stepTracker;
  tracker.innerHTML = "";

  for (let i = 0; i < totalSteps; i++) {
    const step = document.createElement("li");
    step.classList.add("step");
    if (i === currentStep) step.classList.add("active");
    step.textContent = i + 1;
    tracker.appendChild(step);

    if (i < totalSteps - 1) {
      const arrow = document.createElement("li");
      arrow.classList.add("arrow");
      arrow.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="4" viewBox="0 0 18 4" fill="none">
          <path d="M1 1.75C0.861929 1.75 0.75 1.86193 0.75 2C0.75 2.13807 0.861929 2.25 1 2.25V1.75ZM17.1768 2.17678C17.2744 2.07915 17.2744 1.92085 17.1768 1.82322L15.5858 0.232233C15.4882 0.134602 15.3299 0.134602 15.2322 0.232233C15.1346 0.329864 15.1346 0.488155 15.2322 0.585786L16.6464 2L15.2322 3.41421C15.1346 3.51184 15.1346 3.67014 15.2322 3.76777C15.3299 3.8654 15.4882 3.8654 15.5858 3.76777L17.1768 2.17678ZM1 2.25H17V1.75H1V2.25Z" fill="#1A1A1A"/>
        </svg>`;
      tracker.appendChild(arrow);
    }
  }
}

// function renderQuestion(selectors) {
//   const questionData = selectors.quizData[currentQuestionIndex];
//   const isMultipleAnswer = questionData.type === "multiple answer";

//   selectors.questionContainer.innerHTML = `
//     <div class="hn_question--title">
//       <h2 class="hn--title">${questionData.title}</h2>
//     </div>
//     <div class="hn_question--content">
//       <h4 class="hn--question">${questionData.question}</h4>
//       <div class="hn--answer_grid ${
//         isMultipleAnswer ? "multiple--answer" : "single--answer"
//       }">
//         ${questionData.answers
//           .map(
//             (answer, index) => `
//               <button class="${
//                 isMultipleAnswer ? "multiple_answer-button" : "answer-button"
//               } ${
//               isMultipleAnswer
//                 ? selectedAnswers[currentQuestionIndex].includes(index)
//                   ? "active"
//                   : ""
//                 : selectedAnswers[currentQuestionIndex] === index
//                 ? "active"
//                 : ""
//             }" data-index="${index}">
//                 <span class="button-text">${answer.text}</span>
//               </button>
//             `
//           )
//           .join("")}
//       </div>
//       ${
//         isMultipleAnswer
//           ? `
//             <div class="hn--answer_button">
//               <button type="button" class="hn-button" ${
//                 selectedAnswers[currentQuestionIndex].length === 0
//                   ? "disabled"
//                   : ""
//               }>
//                 Find the product
//                 <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
//                   <path d="M12.5 4L18.5 10L12.5 16" stroke="#FEFEFE" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
//                   <path d="M1.5 10H18.5" stroke="#FEFEFE" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
//                 </svg>
//               </button>
//             </div>
//           `
//           : ""
//       }
//     </div>
//   `;

//   renderStepPagination(
//     selectors,
//     currentQuestionIndex,
//     selectors.quizData.length
//   );
//   renderPrevButton(selectors);

//   // Click Functionality for Answer Buttons
//   if (isMultipleAnswer) {
//     const optionButtons = selectors.questionContainer.querySelectorAll(
//       ".multiple_answer-button"
//     );
//     optionButtons.forEach((button) => {
//       button.addEventListener("click", function () {
//         const index = parseInt(this.dataset.index);
//         const currentSelections = selectedAnswers[currentQuestionIndex];
//         if (currentSelections.includes(index)) {
//           selectedAnswers[currentQuestionIndex] = currentSelections.filter(
//             (i) => i !== index
//           );
//         } else {
//           selectedAnswers[currentQuestionIndex] = [
//             ...currentSelections,
//             index,
//           ].sort();
//         }
//         renderQuestion(selectors);
//       });
//     });

//     // Find the product button
//     const findButton = selectors.questionContainer.querySelector(".hn-button");
//     if (findButton) {
//       findButton.addEventListener("click", () => {
//         if (selectedAnswers[currentQuestionIndex].length > 0) {
//           selectAnswer(null);
//         }
//       });
//     }
//   } else {
//     const optionButtons =
//       selectors.questionContainer.querySelectorAll(".answer-button");
//     optionButtons.forEach((button) => {
//       button.addEventListener("click", function () {
//         optionButtons.forEach((btn) => btn.classList.remove("active"));
//         this.classList.add("active");
//         selectAnswer(parseInt(this.dataset.index));
//       });
//     });
//   }
// }

function renderQuestion(selectors) {
  const questionData = selectors.quizData[currentQuestionIndex];
  const isMultipleAnswer = questionData.type === "multiple answer";

  selectors.questionContainer.innerHTML = `
    <div class="hn_question--title">
      <h2 class="hn--title">${questionData.title}</h2>
    </div>
    <div class="hn_question--content">
      <h4 class="hn--question">${questionData.question}</h4>
      <div class="hn--answer_grid ${
        isMultipleAnswer ? "multiple--answer" : "single--answer"
      }">
        ${questionData.answers
          .map(
            (answer, index) => `
              <button class="${
                isMultipleAnswer ? "multiple_answer-button" : "answer-button"
              } ${
              isMultipleAnswer
                ? selectedAnswers[currentQuestionIndex].includes(index)
                  ? "active"
                  : selectedAnswers[currentQuestionIndex].length >= 2
                  ? "disabled"
                  : ""
                : selectedAnswers[currentQuestionIndex] === index
                ? "active"
                : ""
            }" data-index="${index}" ${
              isMultipleAnswer &&
              selectedAnswers[currentQuestionIndex].length >= 2 &&
              !selectedAnswers[currentQuestionIndex].includes(index)
                ? "disabled"
                : ""
            }>
                <span class="button-text">${answer.text}</span>
              </button>
            `
          )
          .join("")}
      </div>
      ${
        isMultipleAnswer
          ? `
            <div class="hn--answer_button">
              <button type="button" class="hn-button" ${
                selectedAnswers[currentQuestionIndex].length === 0
                  ? "disabled"
                  : ""
              }>
                Find the product
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M12.5 4L18.5 10L12.5 16" stroke="#FEFEFE" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M1.5 10H18.5" stroke="#FEFEFE" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          `
          : ""
      }
    </div>
  `;

  renderStepPagination(
    selectors,
    currentQuestionIndex,
    selectors.quizData.length
  );
  renderPrevButton(selectors);

  // Click Functionality for Answer Buttons
  if (isMultipleAnswer) {
    const optionButtons = selectors.questionContainer.querySelectorAll(
      ".multiple_answer-button"
    );
    optionButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const index = parseInt(this.dataset.index);
        const currentSelections = selectedAnswers[currentQuestionIndex];

        if (currentSelections.includes(index)) {
          // Unselect if already selected
          selectedAnswers[currentQuestionIndex] = currentSelections.filter(
            (i) => i !== index
          );
          renderQuestion(selectors);
        } else if (currentSelections.length < 2) {
          // Select only if less than 2 answers are selected
          selectedAnswers[currentQuestionIndex] = [
            ...currentSelections,
            index,
          ].sort();
          renderQuestion(selectors);
        }
      });
    });

    // Find the product button
    const findButton = selectors.questionContainer.querySelector(".hn-button");
    if (findButton) {
      findButton.addEventListener("click", () => {
        if (selectedAnswers[currentQuestionIndex].length > 0) {
          selectAnswer(null);
        }
      });
    }
  } else {
    const optionButtons =
      selectors.questionContainer.querySelectorAll(".answer-button");
    optionButtons.forEach((button) => {
      button.addEventListener("click", function () {
        optionButtons.forEach((btn) => btn.classList.remove("active"));
        this.classList.add("active");
        selectAnswer(parseInt(this.dataset.index));
      });
    });
  }
}

function selectAnswer(index) {
  const questionData = selectors.quizData[currentQuestionIndex];
  const isMultipleAnswer = questionData.type === "multiple answer";
  const previousAnswer = isMultipleAnswer
    ? [...selectedAnswers[currentQuestionIndex]]
    : selectedAnswers[currentQuestionIndex];

  // Update selectedAnswers for single answer
  if (!isMultipleAnswer) {
    selectedAnswers[currentQuestionIndex] = index;
  }

  // If answer changed, clear subsequent answers
  if (
    isMultipleAnswer
      ? JSON.stringify(previousAnswer) !==
        JSON.stringify(selectedAnswers[currentQuestionIndex])
      : previousAnswer !== index
  ) {
    for (let i = currentQuestionIndex + 1; i < selectors.quizData.length; i++) {
      selectedAnswers[i] =
        selectors.quizData[i].type === "multiple answer" ? [] : null;
    }
  }

  // Move to next question or result
  if (currentQuestionIndex < selectors.quizData.length - 1) {
    currentQuestionIndex++;
    loadingQuestion(selectors);
    renderPrevButton(selectors);
  } else {
    loadingResult(selectors);
  }
}

function renderPrevButton(selectors) {
  selectors.headerContainer.querySelector(".hn--prev_btn")?.remove();
  if (currentQuestionIndex > 0) {
    const prevBtn = document.createElement("button");
    prevBtn.classList.add("hn--prev_btn");
    prevBtn.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <rect width="32" height="32" rx="16" fill="#FCF7ED" fill-opacity="0.5"/>
        <path d="M14 10L8 16L14 22" stroke="#1A1A1A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M25 16H8" stroke="#1A1A1A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
    prevBtn.addEventListener("click", () => {
      if (currentQuestionIndex > 0) {
        currentQuestionIndex--;
        loadingQuestion(selectors);
        renderPrevButton(selectors);
      }
    });
    selectors.headerContainer.appendChild(prevBtn);
  }
}

function loadingQuestion(selectors) {
  selectors.questionOverlay.style.display = "flex";
  setTimeout(() => {
    selectors.questionOverlay.style.display = "none";
    renderQuestion(selectors);
  }, 500);
}

function loadingResult(selectors) {
  selectors.resultOverlay.style.display = "flex";
  setTimeout(() => {
    selectors.resultOverlay.style.display = "none";
    renderResult(selectors);
  }, 1500);
}

function renderResult(selectors) {
  const resultData = selectors.resultData[0];
  const productData = resultData.product;

  selectors.resultContainer.innerHTML = `
    <div class="hn_question--title">
      <h2 class="hn--title">${resultData.title}</h2>
    </div>
    <div class="hn_result--content">
      <div class="hn_result-header">
        <div class="hn--text">${resultData.text}</div>
        <span class="hn--offer">Claim your personalized offer</span>
      </div>
      <div class="hn_result-body">
        <div class="product-media">
          <img src="${productData.featured_image}" alt="${productData.title}" class="image">
          <div class="upper-part for-mobile">
            <div class="loox-rating" data-id="${productData.id}" data-rating="${resultData.avg_rating}" data-raters="${resultData.num_reviews}" data-pattern="[rating] ([count])"></div>
            <h4 class="product-title">${productData.title}</h4>
          </div>
        </div>
        <div class="product-content">
          <div class="upper-part">
            <div class="loox-rating for-desktop" data-id="${productData.id}" data-rating="${resultData.avg_rating}" data-raters="${resultData.num_reviews}" data-pattern="[rating] ([count])"></div>
            <h4 class="product-title for-desktop">${productData.title}</h4>
            <ul class="icon_list">
              <li class="item">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M18.7 7.1999C18.3 6.7999 17.7 6.7999 17.3 7.1999L9.8 14.6999L6.7 11.5999C6.3 11.1999 5.7 11.1999 5.3 11.5999C4.9 11.9999 4.9 12.5999 5.3 12.9999L9.1 16.7999C9.3 16.9999 9.5 17.0999 9.8 17.0999C10.1 17.0999 10.3 16.9999 10.5 16.7999L18.7 8.5999C19.1 8.1999 19.1 7.5999 18.7 7.1999Z" fill="#FF30CC"/>
                </svg>
                ${resultData.list_1}
              </li>
              <li class="item">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M18.7 7.1999C18.3 6.7999 17.7 6.7999 17.3 7.1999L9.8 14.6999L6.7 11.5999C6.3 11.1999 5.7 11.1999 5.3 11.5999C4.9 11.9999 4.9 12.5999 5.3 12.9999L9.1 16.7999C9.3 16.9999 9.5 17.0999 9.8 17.0999C10.1 17.0999 10.3 16.9999 10.5 16.7999L18.7 8.5999C19.1 8.1999 19.1 7.5999 18.7 7.1999Z" fill="#FF30CC"/>
                </svg>
                ${resultData.list_2}
              </li>
              <li class="item">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M18.7 7.1999C18.3 6.7999 17.7 6.7999 17.3 7.1999L9.8 14.6999L6.7 11.5999C6.3 11.1999 5.7 11.1999 5.3 11.5999C4.9 11.9999 4.9 12.5999 5.3 12.9999L9.1 16.7999C9.3 16.9999 9.5 17.0999 9.8 17.0999C10.1 17.0999 10.3 16.9999 10.5 16.7999L18.7 8.5999C19.1 8.1999 19.1 7.5999 18.7 7.1999Z" fill="#FF30CC"/>
                </svg>
                ${resultData.list_3}
              </li>
            </ul>
          </div>
          <div class="product-button_wrapper">
            <a href="/products/${productData.handle}" class="product-button">Unlock My Match</a>
          </div>
        </div>
      </div>
      
    </div>
  `;
  selectors.stepTracker.innerHTML = "";
  selectors.questionContainer.innerHTML = "";
  selectors.headerContainer.querySelector(".hn--prev_btn")?.remove();
}

runAt(".hn_quiz--section", globalFunction);
